<template>
  <v-row no-gutters>
    <v-col cols="12" sm="12" md="12" @click="dialog = true">
      <div @click="dialog = true"><slot> </slot></div>
      <v-dialog v-model="dialog" persistent max-width="1200px">
        <v-card>
          <v-card-text class="pt-3">
            <span class="headline">{{ $t("components.ajaxBookingRailSelect.railBookingList") }}</span>
            <booking-general-data-table>
              <template v-slot:action="booking">
                <v-btn
                  icon
                  class="ma-0"
                  v-on:click="assignBooking(booking)"
                  :disabled="$store.getters['Ajax/loading']"
                  :title="$t('components.ajaxBookingRailSelect.pinBooking')"
                >
                  <v-icon>mdi-pin</v-icon>
                </v-btn>
              </template>
            </booking-general-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click.native="dialog = false">{{ $t("global.close") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import dayOfWeek from "../../repository/dayOfWeekFromDate";
import filterOverAllProperty from "../../repository/filterOverAllProperty";
import BookingGeneralDataTable from "../Booking/BookingGeneralDataTable"; // webpack alias

export default {
  name: "AjaxBookingGeneralSelect",
  components: { BookingGeneralDataTable },
  data: () => ({
    newId: -1,
    uploadButton: true,
    dialog: false,
    validationError: false,
    //validationMessage: [],
    //items: [],
    search: "",
    uploadedFile: null,
    //loading: false,

    loading: false
  }),
  watch: {
    selectModel(val) {
      this.onChange(val);
    }
  },
  computed: {
    items() {
      if (this.model != null) {
        return [{ id: this.model, text: "" + this.ticketNumber }];
      }
      return [];
    },
    contextModel: {
      set: function(value) {
        this.$emit("update:model", value);
      },
      get: function() {
        return this.model;
      }
    }
  },
  methods: {
    assignBooking(item) {
      console.log(item);
      this.$emit("selectedBooking", item.booking.id);
      this.dialog = false;
    },
    dayOfWeek: dayOfWeek,
    filterOverAllProperty: filterOverAllProperty
  },
  created() {},
  beforeDestroy() {
    this.$emit("update:model", null);
    this.$emit("update:ticketNumber", null);
    this.$emit("fileRemoved", { id: this.contextFileId });
  }
};
</script>

<style scoped>
.chip--small {
  height: 22px;
}
</style>
